import * as React from "react";
import { IChildrenOnlyProps } from "./ichildren-only-props";

/**
 * Display html using React's dangerous innerHtml method. Note this assumes pre-sanitised html, which should occur server side
 * @param props html content props
 */
export const Content = (props: IChildrenOnlyProps) => (
    <div style={{padding: 20}}>
        {props.children}
    </div>
);


// WEBPACK FOOTER //
// ./src/components/content.tsx